import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  ApiCollectionResponse,
  ApiSingleResponse,
} from '../interfaces/responses/api-response';
import { LeaderboardEntry, StudentXpSummary } from '../interfaces/gamification';

@Injectable({
  providedIn: 'root',
})
export class GamificationService {
  private baseUrl = `${environment.BASE_URL}/gamification`;

  constructor(private http: HttpClient) {}

  /**
   * Classement des Top N élèves par XP total.
   * @param top Nombre d'élèves à retourner (défaut 5)
   */
  getLeaderboard(top: number = 5): Observable<ApiCollectionResponse<LeaderboardEntry>> {
    return this.http.get<ApiCollectionResponse<LeaderboardEntry>>(
      `${this.baseUrl}/leaderboard`,
      { params: { top: top.toString() } },
    );
  }

  /**
   * Résumé XP de l'élève connecté.
   */
  getMyXpSummary(): Observable<ApiSingleResponse<StudentXpSummary>> {
    return this.http.get<ApiSingleResponse<StudentXpSummary>>(
      `${this.baseUrl}/my-xp`,
    );
  }

  /**
   * Résumé XP d'un élève spécifique (vue admin/prof).
   */
  getStudentXpSummary(studentId: number): Observable<ApiSingleResponse<StudentXpSummary>> {
    return this.http.get<ApiSingleResponse<StudentXpSummary>>(
      `${this.baseUrl}/students/${studentId}/xp`,
    );
  }
}
